module.exports = __webpack_public_path__ + "static/media/carrobrasil-alpha.7b954f30.png";